export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      layout: "Dubai",
      sidebar: {
        type: "compact-wrapper",
      },
      sidebar_setting: "default-sidebar",
    },
    color: {
      primary_color: "#ff0094",
      secondary_color: "#00000",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
}
export default ConfigDB;
